import React from "react";

const EtransferOptionsBus = (props) => {
  const options = [
    {
      text: 'Enhanced Features',
      handler: props.actionProvider.handleEufBus,
      id: 1
    },
    {
      text: 'Help, I’m having trouble with a current transaction.',
      handler: props.actionProvider.handleEtransferBus1,
      id: 2
    },
    {
      text: 'Can I use Interac e-Transfer for my business?',
      handler: props.actionProvider.handleEtransferBus2,
      id: 3
    },
    {
      text: 'What types of business would use Interac e-Transfer?',
      handler: props.actionProvider.handleEtransferBus3,
      id: 4
    },
    {
      text: 'How much does it cost to send money via Interac e-Transfer?',
      handler: props.actionProvider.handleEtransferBus4,
      id: 5
    },
  ];

  const optionsMarkup = options.map((option) => (
    <label key={option.text.replace(/\s+/g, '-').toLowerCase()}>
    <input
      type="radio"
      className='consumer-product-button'
      value={option.id}
      name="consumer"
      onClick={option.handler}
    />
    
    <span className={option.text.replace(/\s+/g, '-').toLowerCase()}>{option.text}</span>
      </label>
  ));

  return <div className='consumer-products-container etransfer-products'>{optionsMarkup}</div>;
};

export default EtransferOptionsBus;